import { render, staticRenderFns } from "./BibLabelSelectPI.vue?vue&type=template&id=66c9f5ef&scoped=true&"
import script from "./BibLabelSelectPI.vue?vue&type=script&lang=js&"
export * from "./BibLabelSelectPI.vue?vue&type=script&lang=js&"
import style0 from "./BibLabelSelectPI.vue?vue&type=style&index=0&id=66c9f5ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9f5ef",
  null
  
)

export default component.exports